import React from 'react';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import aumentLogo from '../../../assets/images/aument-logo.png';

interface IAppLogo {
  onClick?: () => void;
}

const AppLogo: React.FC<IAppLogo> = ({onClick}) => {
  const useStyles = makeStyles(() => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',
      alignItems: 'center',
    },
    logo: {
      height: 36,
      marginRight: 10,
    },
  }));
  const classes = useStyles();
  return (
    <Box onClick={onClick} className={classes.logoRoot}>
      <img
        className={classes.logo}
        src={aumentLogo}
        alt='crema-logo'
      />
    </Box>
  );
};

export default AppLogo;
